import styles from './GeofenceInteractionTypeRenderer.module.scss';
import { GIType } from '@customer/store/apis/interactionsApi';
import { useTranslation } from 'react-i18next';
import { EmptyCell } from '../../formatters/genericFormatters';
import { ReactElement } from 'react';

interface GeofenceInteractionTypeRendererProps {
  value?: GIType;
  size?: 'small' | 'large';
}

export function GeofenceInteractionTypeRenderer({
  value,
  size = 'large',
}: GeofenceInteractionTypeRendererProps): ReactElement | string {
  const { t } = useTranslation();

  if (typeof value !== 'undefined') {
    return (
      <span className={`${styles.label} ${styles[`label--${size}`]}`}>{t(`gi.name.${value}`)}</span>
    );
  }

  return EmptyCell;
}

export default GeofenceInteractionTypeRenderer;
